"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateStringId = exports.generateNumericId = void 0;
var generateStringId = exports.generateStringId = function generateStringId(_ref) {
  var _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? 'New' : _ref$prefix,
    _ref$single = _ref.single,
    single = _ref$single === void 0 ? undefined : _ref$single,
    list = _ref.list;
  if (list.length === 0 && single !== undefined) {
    return single;
  }
  if (!list.find(function (item) {
    return item.id.value === prefix;
  })) {
    return prefix;
  }
  var counter = 2;
  // eslint-disable-next-line no-loop-func
  while (list.find(function (item) {
    return item.id.value === "".concat(prefix, " (").concat(counter, ")");
  })) {
    counter++;
  }
  return "".concat(prefix, " (").concat(counter, ")");
};
var generateNumericId = exports.generateNumericId = function generateNumericId(_ref2) {
  var list = _ref2.list;
  var counter = 0;
  // eslint-disable-next-line no-loop-func
  while (list.find(function (item) {
    return item.id.value === counter;
  })) {
    counter++;
  }
  return counter;
};